<template>
    <div class="item">
        <div class="item-left">
            <van-checkbox v-model="p_info.checked" checked-color="#07c160" @change="selectChanged"></van-checkbox>
        </div>
        <div class="item-main">
            <div class="panel">
                <van-row>
                    <van-col span="6">
                        <div class="item-img"><img :src="p_info.thumb" /></div>
                    </van-col>
                    <van-col span="18">
                        <div class="center">
                            <div class="text">{{p_info.product_name}}</div>
                            <div class="bottom-panel">
                                <div class="price">
                                    <span class="price-code">￥</span>
                                    <span>{{p_info.price}}</span>
                                </div>
                                <div class="origin-price">
                                    <span class="price-code">￥</span>
                                    <span>{{p_info.origin_price}}</span>
                                </div>
                                <div class="order-qty">
                                    <van-stepper v-model="p_info.order_qty" />
                                </div>
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <div class="bottom">
                        <span class="total">总价￥<span class="val">{{total_money}}</span></span>
                        <span class="coupon">优惠券￥<span class="val">{{p_info.coupon_money}}</span></span>
                        <span class="real">实付￥<span class="val">{{real_money}}</span></span>
                    </div>
                </van-row>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "OrderSelectItem",
        props:{
            p_info:{
                type:Object,
                default:null,
                required:true,
            },
        },
        data(){
            return{
                moment:this.$moment,
                item_checked:true,
                order_qty:1,
            }
        },
        computed:{
            total_money(){
                return parseFloat(this.p_info.price)*parseInt(this.p_info.order_qty);
            },
            real_money(){
                return this.total_money-this.p_info.coupon_money;
            }
        },
        methods:{
            selectChanged(checked){
                let val={
                    id:this.p_info.id,
                    money:this.real_money,
                    checked:checked
                };
                this.$emit('check_changed',val);
            }
        },
        watch:{
            real_money(){
                let val={
                    id:this.p_info.id,
                    money:this.real_money,
                    order_qty:this.p_info.order_qty
                };
                this.$emit('real_money_changed',val);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .item{
        background-color: #FFFFFF;
        margin: 4px;
        border-radius: 10px;
        /*border: 1px solid red;*/
        height: 130px;
        display: flex;
        align-items: center;
        .item-left{
            width: 6%;
        }
        .item-main{
            width: 90%;
            /*border: 1px solid green;*/
        }
    }
    .panel{
        .top{
            text-align: left;
            padding: 4px;
            .logo{
                display: inline-block;
                line-height: 30px;
                img{
                    vertical-align: middle;
                    width: 20px;
                    height: 20px;
                }
            }
            .title{
                display: inline-block;
                font-size: 12px;
                color: #666666;
                font-weight: bold;
                padding-left: 5px;
            }
            .status{
                display: inline-block;
                float: right;
                padding: 4px;
            }
        }
        .bottom{
            text-align: left;
            padding: 4px;
            .total{
                font-size: 12px;
                color: #666666;
                .val{
                    font-size: 12px;
                }
            }
            .coupon{
                padding-left: 10px;
                font-size: 12px;
                color: #666666;
                .val{
                    font-size: 12px;
                }
            }
            .real{
                padding-left: 14px;
                font-size: 12px;
                font-weight: bold;
                color: #E87748;
                .val{
                    font-size: 16px;
                }
            }
        }
        .item-img{
            font-size:0;
            padding: 0 0 4px 4px;
            img {
                width: 90px;
                height: 90px;
            }
        }
        .center{
            text-align: left;
            padding-left: 14px;
            position: relative;
            min-height: 95px;
            .text{
                font-size: 14px;
                color: #333333;
            }
            .order-time{
                color: #999999;
                padding-top: 4px;
                .label{
                    font-size: 12px;
                }
                .val{
                    font-size: 10px;
                }
            }
            .bottom-panel{
                position: absolute;
                bottom: 6px;
                width: 80%;
                .price{
                    display: inline-block;
                    font-size: 14px;
                    font-weight: bold;
                    color: #E87748;
                    .price-code{
                        font-size: 10px;
                    }
                }
                .origin-price{
                    display: inline-block;
                    padding-left: 4px;
                    font-size: 12px;
                    color: #999999;
                    text-decoration:line-through;
                    .price-code{
                        font-size: 10px;
                    }
                }
                .order-qty{
                    float: right;
                }
            }

        }
        .right{
            text-align: right;
            padding: 4px 4px 0 0;
            .price{
                font-size: 14px;
                color: #666666;
            }
            .qty{
                font-size: 10px;
                color: #666666;
            }
        }
    }
</style>
